<template>
  <div id="staff-list">
    <v-card class="pa-4 elevation-6 rounded-xl">
      <!-- Header -->
      <v-card-title>
        <span class="text-h5 font-weight-bold">{{ PageTitle }}</span>
        <v-spacer></v-spacer>
        <v-btn
          v-if="refreshButtonFlag"
          elevation="2"
          color="primary"
          small
          class="white--text mr-2"
          @click.prevent="refreshPageData"
        >
          <v-icon left small>mdi-refresh</v-icon> Refresh
        </v-btn>
        <v-btn
          v-if="refreshButtonFlag"
          elevation="2"
          color="success"
          small
          class="white--text"
          @click.prevent="addRecordPrompt = true"
        >
          <v-icon left small>mdi-account-plus</v-icon> Assign Committee
        </v-btn>
      </v-card-title>

      <v-card-subtitle>
        <span class="text-subtitle-2 grey--text">{{ PageDescription }}</span>
      </v-card-subtitle>

      <!-- Table Section -->
      <v-card-text>
        <!-- Loader -->
        <div class="d-flex justify-center mb-3" v-if="LoadingFlag">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>

        <!-- Search & Record Count -->
        <v-row class="mb-2">
          <v-col cols="12" md="6">
            <h3 class="text-primary">{{ rows.length }} records found.</h3>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search records"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- Data Table -->
        <v-data-table
          class="styled-table elevation-2 rounded-lg"
          dense
          outlined
          :search="search"
          :item-key="tableOptions1.ItemKey"
          :headers="tableColumns1"
          :items="rows"
          :items-per-page="tableOptions1.ItemsPerPage"
          :footer-props="tableOptions1.FooterProps"
        >
          <!-- Status Chips -->
          <template v-slot:[`item.StatusTxt`]="{ item }">
            <v-chip small dark class="elevation-2" :color="item.StatusTxtColor">
              {{ item.StatusTxt }}
            </v-chip>
          </template>

          <template v-slot:[`item.VerifyStatusTxt`]="{ item }">
            <v-chip
              small
              dark
              class="elevation-2"
              :color="item.VerifyStatusTxtColor"
            >
              {{ item.VerifyStatusTxt }}
            </v-chip>
          </template>

          <template v-slot:[`item.PresidentStatusTxt`]="{ item }">
            <v-chip
              small
              dark
              class="elevation-2"
              :color="item.PresidentStatusTxtColor"
            >
              {{ item.PresidentStatusTxt }}
            </v-chip>
          </template>

          <!-- Action Icons -->
          <template v-slot:[`item.Actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="info"
                  small
                  @click="editData(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </template>

          <!-- Member Image -->
          <template v-slot:[`item.MemberImage`]="{ item }">
            <v-avatar size="64">
              <img :src="item.MemberImage" alt="Member" />
            </v-avatar>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dialogs -->
    <v-dialog
      v-model="previewRecordPrompt"
      max-width="75%"
      transition="dialog-bottom-transition"
    >
      <v-card class="rounded-xl elevation-12">
        <nomination-preview
          pageDescription="Nomination Details"
          :showDialog="previewRecordPrompt"
          @hideDialog="hidePreviewRecordPrompt($event)"
          :row="selectedData"
          v-if="previewRecordPrompt"
        />
      </v-card>
    </v-dialog>

    <v-dialog v-model="addRecordPrompt" max-width="75%">
      <v-card class="rounded-xl elevation-12">
        <nomination-committee-store
          :showDialog="addRecordPrompt"
          @hideDialog="hideAddRecordPrompt($event)"
          :row="selectedData"
          v-if="addRecordPrompt"
        />
      </v-card>
    </v-dialog>

    <v-dialog v-model="editRecordPrompt" max-width="75%">
      <v-card class="rounded-xl elevation-12">
        <nomination-committee-edit
          :showDialog="editRecordPrompt"
          @hideDialog="hideEditRecordPrompt($event)"
          :row="selectedData"
          v-if="editRecordPrompt"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import NominationPreview from "@/view/pages/erp/events/nomination/NominationPreview.vue";
import NominationCommitteeStore from "@/view/pages/erp/events/nomination-committee/NominationCommitteeStore.vue";
import NominationCommitteeEdit from "@/view/pages/erp/events/nomination-committee/NominationCommitteeEdit.vue";
export default {
  mixins: [common],
  components: {
    NominationPreview,
    NominationCommitteeStore,
    NominationCommitteeEdit,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: 0,

      refreshButtonFlag: true,
      floatButtonFlag: false,
      selected1: "",
      rows: [],
      tableColumns1: [],
      tableOptions1: {},
      selected: [],
      search: "",
      CurrentYearId: 0,
      previewRecordPrompt: false,

      DownloadFlag: false,
      ExcelFileName: "",
      ExcelFields: "",

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      editRecordPrompt: false,

      editFlag: false,

      selectedData: {},
      addRecordPrompt: false,

      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,

      SearchId: "",
      SearchIdRules: [(v) => !!v || "Search Type is required"],

      LoadingFlag: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      LomCodeRules: [],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      NominationDesignationOptions: [],
      NominationDesignationRules: [],
      NominationDesignationOptionsLoading: false,
      NominationDesignation: "",
      RoleId: "",
    };
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.LoadingFlag = false;
      this.ZoneCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode");
      // this.getRegionCodeOptions();
      this.LomCode = "";
      this.getLomCodeOptions();
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LoadingFlag = false;
      this.LomCodeOptionsLoading = false;
    },
    NominationDesignation: function () {
      console.log("watch NominationDesignation");
      this.NominationDesignationLoading = false;
      var temp_code = this.NominationDesignation;
      console.log({ temp_code });
    },
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var PagePermissionFlag = tr.PagePermissionFlag;
        console.log({ PagePermissionFlag });

        if (!PagePermissionFlag) {
          this.$router.push("/access-denied");
        }

        var PagePermissionTxt = tr.PagePermissionTxt;
        console.log({ PagePermissionTxt });

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        // this.LomCode = LomId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        // RoleId = 4;
        this.RoleId = RoleId;

        this.pageData();
      }
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "nomination_committee",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.getTableRecords();
    },
    hidePreviewRecordPrompt(flag) {
      console.log("hidePreviewRecordPrompt called");
      console.log({ flag });
      this.previewRecordPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    pageData() {
      console.log("pageData called");
      this.getZoneCodeOptions();
      this.getNominationDesignationOptions();
    },
    hideAddRecordPrompt(flag) {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      console.log(flag);
      if (flag) {
        this.getTableRecords();
      }
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    hideEditRecordPrompt() {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      // console.log(flag);
      // if (flag) {
      this.getTableRecords();
      // }
    },
    previewData(tr) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    editData(tr) {
      console.log("editData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.editRecordPrompt = true;
      } else {
        var message = "Kindly select one member to edit";
        this.toast("error", message);
      }
    },
    getNominationDesignationOptions() {
      console.log("getNominationDesignationOptions called");
      const selectbox1_source = "NominationDesignation";
      const selectbox1_destination = "NominationDesignationOptions"; // must match autocomplete items
      const selectbox1_url = "api/nomination-designation/options";
      const selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      var areaCode = this.AreaCode;
      console.log("yearCode=" + yearCode + ", areaCode=" + areaCode);
      if (yearCode != "") {
        this.LoadingFlag = true;
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var YearCode = this.JciYearCode;
      var ZoneCode = this.ZoneCode;
      var RegionCode = this.RegionCode;
      console.log(
        "YearCode=" +
          YearCode +
          ", ZoneCode=" +
          ZoneCode +
          ", RegionCode=" +
          RegionCode
      );
      if (YearCode != "") {
        this.LoadingFlag = true;
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/judge/lists";
      var upload = {
        UserInterface: 3,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var successTxt = "";
      var errorTxt = "";
      var flag = 0;

      this.rows = [];
      this.ResultFlag = false;
      this.LoadingFlag = true;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ResultFlag = true;
          thisIns.LoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          output = response.data.output;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);
          successTxt = response.data.success;
          errorTxt = response.data.error;
          console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

          var options = records.TableOptions;
          thisIns.tableOptions1 = options;

          if (flag == 1) {
            thisIns.rows = records.TableData;
            thisIns.tableColumns1 = records.TableHeader;
            thisIns.tableOptions1 = records.TableOptions;

            thisIns.DownloadFlag = options.ExcelDownloadFlag;
            thisIns.ExcelFileName = options.ExcelFileName;
            thisIns.ExcelFields = options.ExcelFields;

            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.toast("error", error);
          thisIns.ResultFlag = true;
          thisIns.LoadingFlag = false;
        });
    },
    deleteConfirmAlert(tr) {
      console.log("deleteConfirmAlert called");
      var message = "";
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var htmlTxt = "";
        htmlTxt += "<br/> Member Name <b> " + tr.MemberName + "</b>";
        htmlTxt += "<br/> Designation Name  <b> " + tr.DesignationName + "</b>";

        Swal.fire({
          title: "Do you want to continue?",
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Delete`,
          confirmButtonColor: "#d33",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.deleteData(tr.NominationMember);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        if (n1 == 0) {
          message += "Kindly select one record to delete. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    deleteData(NominationMember) {
      console.log("deleteData is called");

      console.log("NominationMember=" + NominationMember);

      if (NominationMember > 0) {
        this.DeleteLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/nomination-member/destroy";
        var upload = {
          UserInterface: 1,
          NominationMember: NominationMember,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.DeleteLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.getTableRecords();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
            thisIns.DeleteLoadingFlag = false;
          });
      } else {
        var message = "Nomination Member Id should not be empty. ";
        this.sweetAlert("error", message, false);
      }
    },
    regenerateApplication(item) {
      console.log("regenerateApplication is called");

      var NominationMember = item.NominationMemberId;
      var NominationId = item.NominationId;
      var MemberId = item.MemberId;

      console.log("NominationMember=" + NominationMember);
      console.log("NominationId=" + NominationId);
      console.log("MemberId=" + MemberId);

      if (NominationMember > 0 && NominationId > 0 && MemberId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/nomination/regeneration-application";
        var upload = {
          UserInterface: 1,
          Nomination: NominationId,
          NominationMember: NominationMember,
          Member: MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.getTableRecords();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
            thisIns.DeleteLoadingFlag = false;
          });
      } else {
        var message = "";
        if (NominationMember == 0 && NominationMember != "") {
          message += "Nomination Member Id should not be empty. ";
        }
        if (NominationId == 0 && NominationId != "") {
          message += "Nomination Id should not be empty. ";
        }
        if (MemberId == 0 && MemberId != "") {
          message += "Member Id should not be empty. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
/* This is for documentation purposes and will not be needed in your application */

#staff-list {
  .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom {
    bottom: 12%;
  }
  .v-speed-dial--right {
    right: 5%;
  }
}
#staff-list {
  .styled-table {
    tr:nth-child(even) {
      background-color: #f9f9f9;
    }
    tr:hover {
      background-color: #f1f5ff;
    }
  }
}
</style>